// extracted by mini-css-extract-plugin
export default {"bottomRightPosition":"a8Ki6V4xuhdJYqO9W1Br"};